const space = {
  xs: '0.375rem', // 6px
  sm: '0.625rem', // 10px
  md: '1rem', // 16px
  lg: '1.25rem', // 20px
  xl: '2.5rem', // 40px
};

export default space;
